// Quantity steppers: buttons with data-qty-change adjust the sibling input.
// If the input has data-submit-on-change (cart page), submit its form so
// Shopify recalculates the cart without any extra JS plumbing.
document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-qty-change]');
  if (!button) return;
  var wrapper = button.closest('.qty');
  var input = wrapper && wrapper.querySelector('input[type="number"]');
  if (!input) return;
  event.preventDefault();
  var step = parseInt(button.getAttribute('data-qty-change'), 10);
  var min = parseInt(input.min || '0', 10);
  var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
  if (next === parseInt(input.value, 10)) return;
  input.value = next;
  if (input.hasAttribute('data-submit-on-change') && input.form) {
    input.form.submit();
  }
});

// Mobile menu: hamburger toggles the slide-down panel under the header.
document.addEventListener('click', function (event) {
  var toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;
  var open = document.body.classList.toggle('mobile-menu-open');
  document.body.classList.remove('search-open');
  toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
});

// Search panel: magnifier button toggles the slide-down search under the header.
document.addEventListener('click', function (event) {
  var toggle = event.target.closest('[data-search-toggle]');
  if (!toggle) return;
  var open = document.body.classList.toggle('search-open');
  document.body.classList.remove('mobile-menu-open');
  toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  var input = document.querySelector('.search-panel__input');
  var box = document.querySelector('[data-search-results]');
  if (open) {
    if (input) input.focus();
  } else {
    if (input) input.value = '';
    if (box) { box.hidden = true; box.innerHTML = ''; }
  }
});
document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    document.body.classList.remove('search-open');
  }
});

// Live search suggestions: query Shopify predictive search as the user types
// and render the top matches under the input, mock-style.
(function () {
  document.addEventListener('input', function (event) {
    var input = event.target.closest('.search-panel__input');
    if (!input) return;
    var box = document.querySelector('[data-search-results]');
    if (!box) return;
    clearTimeout(input._suggestTimer);
    var q = input.value.trim();
    if (!q) { box.hidden = true; box.innerHTML = ''; return; }
    input._suggestTimer = setTimeout(function () {
      if (input._suggestAbort) input._suggestAbort.abort();
      input._suggestAbort = new AbortController();
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=4';
      fetch(url, { signal: input._suggestAbort.signal })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (input.value.trim() !== q) return;
          var products = (((data || {}).resources || {}).results || {}).products || [];
          if (!products.length) { box.hidden = true; box.innerHTML = ''; return; }
          var urls = products.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
            if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=56';
            return img;
          });
          // Preload thumbnails (capped at 400ms) so the dropdown appears complete.
          var preload = urls.filter(Boolean).map(function (u) {
            return new Promise(function (resolve) {
              var im = new Image();
              im.onload = im.onerror = resolve;
              im.src = u;
            });
          });
          var timeout = new Promise(function (resolve) { setTimeout(resolve, 400); });
          Promise.race([Promise.all(preload), timeout]).then(function () {
            if (input.value.trim() !== q) return;
            var esc = function (s) {
              var d = document.createElement('div');
              d.textContent = s == null ? '' : String(s);
              return d.innerHTML;
            };
            var html = products.map(function (p, i) {
              return '<a href="' + esc(p.url) + '">' +
                (urls[i] ? '<img src="' + esc(urls[i]) + '" alt="" decoding="async">' : '<span class="search-panel__thumb"></span>') +
                '<span class="search-panel__result-title">' + esc(p.title) + '</span>' +
                '<span class="search-panel__result-price">$' + esc(p.price) + '</span>' +
              '</a>';
            }).join('');
            html += '<a class="search-panel__all" href="/search?type=product&q=' + encodeURIComponent(q) + '">See all results &rarr;</a>';
            box.innerHTML = html;
            box.hidden = false;
          });
        })
        .catch(function () {});
    }, 250);
  });
})();
